import { jsx as n } from "react/jsx-runtime";
import "react";
import { NavList as o } from "../NavList/NavList.js";
import '../../assets/InlineNavigation.css';const r = {
  "inline-navigation": "_inline-navigation_3u114_1",
  "anchor-tag--image": "_anchor-tag--image_3u114_10"
};
function f({ links: t = [], classname: i = "", position: e = "left" }) {
  const a = /* @__PURE__ */ new Map([
    ["left", "flex-start"],
    ["right", "flex-end"],
    ["center", "center"]
  ]);
  return /* @__PURE__ */ n(
    "nav",
    {
      className: r["inline-navigation"],
      style: {
        "--inline-nav-justify-content": a.get(e)
      },
      children: /* @__PURE__ */ n(o, { links: t, classname: i })
    }
  );
}
export {
  f as InlineNavigation,
  f as default
};
